export const checkExternalLink = (url?: string | null) => {
  if (typeof url !== "string") return false;

  return url.includes("www.daangn.com");
};
